import { CircularProgress } from "@material-ui/core"
import React from "react"

export const Loader = () => <CircularProgress/>
